import { motion } from "framer-motion";
import { Microscope, Box, Film, Download, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Header({ activeView, setActiveView, onExport, hasData, has3DData, hasTimeLapseData }) {
  return (
    <header className="sticky top-0 z-50 glass border-b border-white/5">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="relative">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center">
                <Microscope className="w-5 h-5 text-white" />
              </div>
              <div className="absolute -bottom-1 -right-1 w-3 h-3 rounded-full bg-green-500 border-2 border-background" />
            </div>
            <div>
              <h1 className="font-chivo text-xl font-bold tracking-tight text-foreground">
                Coloc3D-STL
              </h1>
              <p className="text-xs text-muted-foreground">
                Colocalization Analysis
              </p>
            </div>
          </div>

          {/* View Toggle */}
          {hasData && (
            <div className="flex items-center gap-2 p-1 rounded-full bg-secondary/50">
              <ViewButton
                active={activeView === "3d"}
                onClick={() => setActiveView("3d")}
                icon={<Box className="w-4 h-4" />}
                label="3D View"
                disabled={!has3DData}
              />
              <ViewButton
                active={activeView === "timelapse"}
                onClick={() => setActiveView("timelapse")}
                icon={<Film className="w-4 h-4" />}
                label="Time-lapse"
                disabled={!hasTimeLapseData}
              />
            </div>
          )}

          {/* Actions */}
          <div className="flex items-center gap-3">
            {hasData && (
              <Button
                variant="outline"
                size="sm"
                onClick={onExport}
                className="gap-2 rounded-full"
                data-testid="export-btn"
              >
                <Download className="w-4 h-4" />
                <span className="hidden sm:inline">Export CSV</span>
              </Button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

function ViewButton({ active, onClick, icon, label, disabled }) {
  return (
    <button
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={`
        relative flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium
        transition-colors duration-200
        ${disabled 
          ? "text-muted-foreground/40 cursor-not-allowed opacity-50" 
          : active 
            ? "text-white" 
            : "text-muted-foreground hover:text-foreground"
        }
      `}
      data-testid={`view-${label.toLowerCase().replace(" ", "-")}-btn`}
    >
      {active && !disabled && (
        <motion.div
          layoutId="activeView"
          className="absolute inset-0 bg-primary rounded-full"
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
        />
      )}
      <span className="relative z-10 flex items-center gap-2">
        {icon}
        <span className="hidden sm:inline">{label}</span>
      </span>
    </button>
  );
}
